// src/pages/questions/getMarkButtonProps.js

import { getText } from "../../utils/languageUtils";

const getMarkButtonProps = ({
  question,
  isMarked,
  loading,
  language,
  videoBtnDisabled,
  pdfBtnDisabled,
  selectedOptions,
  selectedOptionsMcq,
  CheckIkagiValues,
  snakeLadderWon,
  wrongBucket,
  rightBucket,
  buckets,
  dragDropLength,
  currentPage,
  totalCount,
  setShowResult1,
  setShowResult2,
  MarkAsDoneQuiz,
  flipGameStats,
  translationData
}) => {
  const translations = translationData?.question || {};
  const type = question?.question_type;
  const isDone = isMarked === 1;

  const commonStyles = {
    done: { backgroundColor: "#792110", color: "#ffffff" },
    active: { backgroundColor: "#F3DB7B", color: "#454545" },
    disabled: { backgroundColor: "#C8C8C8", color: "#454545" },
    darkDisabled: { backgroundColor: "#8C8C8C", color: "#454545" },
  };

  const baseProps = {
    onClick: () => MarkAsDoneQuiz(type),
    className: "d-flex align-items-center gap-2",
    loading,
  };

  if (type === "video") {
    return {
      ...baseProps,
      disabled: isDone || videoBtnDisabled || loading,
      label: getText(translations.video_info, language),
      style: isDone ? commonStyles.done : !videoBtnDisabled ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (type === "pdf") {
    return {
      ...baseProps,
      disabled: isDone || pdfBtnDisabled || loading,
      label: getText(translations.read_info, language),
      style: isDone ? commonStyles.done : !pdfBtnDisabled ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (["single_choice_image", "single_select_radio"].includes(type)) {
    const ready = Object.keys(selectedOptions).length > 0;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.mark_as_done, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (type === "ikigai") {
    const ready = CheckIkagiValues?.() === true;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.submit_answer, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }

    if (type === "match_card_pair_game") {
    const ready = flipGameStats.flip_won  === 1;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.submit_answer, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (type === "snake_and_ladder") {
    const ready = snakeLadderWon;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.submit_answer, language),
      style: isDone || ready ? commonStyles.done : commonStyles.darkDisabled,
    };
  }

  if (type === "satyarakshak_game") {
    return {
      ...baseProps,
      disabled: isDone,
      label: getText(translations.submit_answer, language),
      style: isDone ? commonStyles.done : commonStyles.darkDisabled,
    };
  }

  if (type === "quiz_pdf_drag_drop") {
    const ready = Object.keys(wrongBucket).length === 3 && Object.keys(rightBucket).length === 3;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.submit_answer, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (type === "drag_drop") {
    const ready = Number(buckets.length) === Number(dragDropLength);
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.submit_answer, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }

  if (type === "mcq" || type === "multi_select_radio") {
    const ready = selectedOptionsMcq.length > 0;
    return {
      ...baseProps,
      disabled: isDone || !ready || loading,
      label: getText(translations.mark_as_done, language),
      style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
    };
  }
 

  if (type === "imagemap" && currentPage < totalCount) return null;

  if (type === "result_one") {
    return {
      onClick: () => setShowResult1?.(true),
      label: getText(translations.learn_more, language),
      className: "d-flex align-items-center gap-2",
      style: commonStyles.active,
    };
  }

  if (type === "result_two") {
    return {
      onClick: () => setShowResult2?.(true),
      label: getText(translations.learn_more, language),
      className: "d-flex align-items-center gap-2",
      style: commonStyles.active,
    };
  }

  if (type === "thank_you") return null;

  // Default
  const ready = Object.keys(selectedOptions).length > 0;
  return {
    ...baseProps,
    disabled: isDone || !ready || loading,
    label: getText(translations.submit_answer, language),
    style: isDone ? commonStyles.done : ready ? commonStyles.active : commonStyles.disabled,
  };
};

export default getMarkButtonProps;
